import { ExtraCharge } from "@/modules/business/extra-charges";
import { OrderOptionsInterface } from "@/interface/business/order.interface";

export class OrderOption implements OrderOptionsInterface {
  charges: Array<any> = [];
  type: string = "";
  constructor(data?) {
    if (data) {
      this.charges = data.charges.map((charge) => new ExtraCharge(charge));
      this.type = data.type;
    }
  }
}
